var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CheckboxGroup',{staticClass:"cursor-pointer",attrs:{"value":_vm.value,"options":_vm.priorities,"disabled":_vm.disabled},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }